import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import { Calendar } from './Calendar';

const OutOfOfficesView = () => {
  const theme = useTheme();
  return (
    <div style={{ padding: theme.spacing(4) }}>
      <Grid container spacing={4}>
        <Grid
          size={{
            lg: 12,
            md: 12,
            xl: 12,
            xs: 12,
          }}
        >
          <Calendar />
        </Grid>
      </Grid>
    </div>
  );
};

export default OutOfOfficesView;
